import { ReactElement, useRef } from 'react';

import { Icon } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import { WidgetsUrlsDto } from 'src/models/widgets.dto';

import { WidgetSmallPopover } from '../WidgetSmallPopover';

import { Link } from ':components';

export function WidgetSingleLink({
  is_internal,
  url,
}: WidgetsUrlsDto): ReactElement {
  const ref = useRef<HTMLSpanElement | null>(null);

  const tooltip = is_internal
    ? 'Перейти в сервис кабинета'
    : 'Открыть сервис в новой вкладке';

  const currentIcon = is_internal ? Icons.ArrowRight : Icons.OpenInWindow;

  return (
    <Link to={url} noWrapper disableTextDecoration>
      <WidgetSmallPopover text={tooltip}>
        <Icon size='medium' ref={ref} iconName={currentIcon} />
      </WidgetSmallPopover>
    </Link>
  );
}
